export default __webpack_public_path__ + "static/media/header-logo.9ab31b8d.png";